import React, { useEffect, useState } from "react";
import { CopyToCliboard } from "@components/CustomTable/helpers";
import CustomTable from "@components/CustomTable";
import Loader from "@components/LoaderComponent/loader";
import myStore from "./store";
import {
  fetchDynamicFilters,
  transformData,
  displayAttributesTooltip,
} from "@helpers/helpers";
import FiltersWrapper from "@components/FiltersWrapperComponent";
import { Observer } from "mobx-react";
import TitleComponent from "@components/TitleComponent";
import { getLocalConfig } from "@components/CustomTable/helpers";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import TooltipComponent from "@components/TooltipComponent";
import {
  FIRST_INDEX,
  FIRST_ELEMENT,
  SECOND_ELEMENT,
  TOOLTIP_TIMEOUT,
} from "./constants";
import {
  getColumns,
  getChildrenColumns,
  getFilters,
  getSelectedFiltersDisplay,
  PINNING_INITIAL_STATE,
} from "./columnConfig";
import ChildTable from "./ChildTable";
import NoDataComponent from "@helpers/NoDataComponent";

const OutstandingRecords = ({
  exceptionDetailsMatchingRecord,
  setSelectedOutstandingDestinationRows,
  selectedOutstandingDestinationRows,
  setExternalOutstandingRecords,
  recordId,
}) => {
  const { t: translate, i18n } = useTranslation();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const [outstandingRecords, setOutStandingRecords] = useState([]);
  const [dynamicFilters, setDynamicFilters] = useState([]);
  const [popupOpen, setPopupOpen] = useState(null);
  const [currentTooltip, setCurrentTooltip] = useState(null);

  const getDynamicFilters = (key, onlyChildren = false) => {
    return transformData(
      (!!dynamicFilters &&
        !!dynamicFilters.length &&
        dynamicFilters.find((filter) => filter.ColumnName === key)?.Values) ||
        [],
      onlyChildren
    );
  };

  useEffect(() => {
    myStore.setAppliedFilters(
      getLocalConfig("OutstandingRecords_filter", location),
      false
    );
    myStore.id = recordId;
    myStore.fillData(false, (data) => {
      setIsLoading(false);
      setOutStandingRecords(data);
      setExternalOutstandingRecords(data);
    });
    fetchDynamicFilters("ManualMatchingFilters", (newFilters) => {
      setDynamicFilters(newFilters);
    });
  }, []);

  const columns = getColumns(translate);
  const childrenColumns = getChildrenColumns(
    translate,
    setCurrentTooltip,
    TOOLTIP_TIMEOUT,
    popupOpen,
    setPopupOpen
  );
  const filters = getFilters(translate, getDynamicFilters);
  const selectedFiltersDisplay = getSelectedFiltersDisplay(translate);

  const renderTables = (oustandingRecords) => {
    const sourceData = [];
    const destinationData = [];
    let matchingRecords = [];
    let childrenRecords = [];
    oustandingRecords?.forEach((record) => {
      matchingRecords.push(record);
      if (!!record.SourceRecords.length) {
        record.SourceRecords.forEach((sourceRecord, index) => {
          sourceData.push(sourceRecord);
          childrenRecords.push({
            parentRecordID: record.MatchingRecordId,
            ...sourceRecord,
            source: "Source",
          });
        });
      }
      if (!!record.DestinationRecords.length) {
        record.DestinationRecords.forEach((destinationRecord, index) => {
          destinationData.push(destinationRecord);
          childrenRecords.push({
            parentRecordID: record.MatchingRecordId,
            ...destinationRecord,
            source: "Destination",
          });
        });
      }
    });

    return (
      <div className="p-5 w-full flex flex-col gap-5">
        <CustomTable
          language={i18n.language}
          externalData={matchingRecords}
          columnsWithoutPin={columns}
          loading={false}
          pinningInitialState={PINNING_INITIAL_STATE}
          setParentSelectedValues={() => {}}
          prefix="AttemptMatching_OutstandingRecords"
          pinnedRowHeight={62}
          maxTableHeight={400}
          showFilter={false}
          minimalTable={true}
          hideActionColumn={true}
          noData={<NoDataComponent />}
          allowRowPinning={false}
          pinCondition={(row) => {
            return true;
          }}
          expandedViewRow={(row) => {
            const children = childrenRecords.filter(
              (record) =>
                record.parentRecordID === row.original.MatchingRecordId
            );
            return (
              <div className="">
                <ChildTable
                  childrenRecords={children}
                  childrenColumns={childrenColumns}
                  selectedOutstandingDestinationRows={
                    selectedOutstandingDestinationRows
                  }
                  setSelectedOutstandingDestinationRows={
                    setSelectedOutstandingDestinationRows
                  }
                  popupOpen={popupOpen}
                  setPopupOpen={setPopupOpen}
                />
              </div>
            );
          }}
          selectableCondition={(row, isHeader) => {
            return false;
          }}
          setExternalSelectedState={(selectedRows) => {
            setSelectedOutstandingDestinationRows(selectedRows);
          }}
          autoFillData={false}
          rowCustomID={(row) => {
            return row.PromotedRecordId;
          }}
          customSubRows={(row) => {
            return row.DestinationRecords;
          }}
          initialTableVisibility={true}
        />
      </div>
    );
  };
  const filterDisplayValues = {};
  const multipleValueColumns = columns
    .filter((column) => column.isMultiple)
    .map((column) => column.accessorKey);

  return (
    <Observer>
      {() => {
        return isLoading || myStore.loading ? (
          <Loader dots withContainer />
        ) : (
          <div className="border-2 border-gray-200 rounded mr-5 text-black dark:border-gray-700">
            <div className="p-5 pb-0 flex flex-col items-start gap-5 ml-12">
              <TitleComponent
                text={translate("outstanding-records.title")}
                size="md"
              />

              <FiltersWrapper
                filterDisplayValues={filterDisplayValues}
                filters={filters}
                selectedFiltersDisplay={selectedFiltersDisplay}
                store={myStore}
                prefix="OutstandingRecords"
                setParentSelectedValues={() => {}}
                multipleValueColumns={multipleValueColumns}
                setOutStandingRecords={setOutStandingRecords}
              />
            </div>
            <div className="pl-0">{renderTables(outstandingRecords?.data)}</div>
            <TooltipComponent
              anchorElement={"attributes-tooltip"}
              toolTipMessage={displayAttributesTooltip(currentTooltip)}
              position="top"
              className="max-w-max z-50 !bg-gray-500"
            />
          </div>
        );
      }}
    </Observer>
  );
};
export default OutstandingRecords;
